module.exports = __webpack_public_path__ + "static/popup-mobile-be03ffb3ab12b20849d1809d94314e24.svg";